/*
 * Copyright (C) Motorola Solutions, INC.
 * All Rights Reserved.
 */

import { Injectable, Signal } from '@angular/core';
//@ts-ignore - this keycloak-js import is ignored to allow jest tests to mock this service.
import Keycloak from 'keycloak-js';
import { createKeycloakSignal, KeycloakEvent, ProvideKeycloakOptions } from 'keycloak-angular';

@Injectable({
    providedIn: 'root'
})
export class KeycloakService {
    public keycloak: Keycloak;
    public keycloakSignal: Signal<KeycloakEvent>;

    constructor() {}

    async init(options: ProvideKeycloakOptions) {
        this.keycloak = new Keycloak(options.config);
        this.keycloakSignal = createKeycloakSignal(this.keycloak);
        return this.keycloak.init(options.initOptions);
    }
}
